import { GradeBand } from "./gradeBand.model"

export const PBSLM_TITLE = "PBS LearningMedia"

export const FORM_STACK_SUPPORT_URL =
    "https://pbs-cjoef.formstack.com/forms/pbs_learningmedia_profile"

export enum SubjectEnum {
    Science = "Science",
    SocialStudies = "Social Studies",
    Mathematics = "Mathematics",
    EnglishLanguageArts = "English Language Arts",
    EngineeringTechnology = "Engineering & Technology",
    HealthPhysicalEducation = "Health & Physical Education",
    Preschool = "Preschool",
    ProfessionalDevelopment = "Professional Development",
    TheArts = "The Arts",
    WorldLanguages = "World Languages",
    NA = "N/A",
}

export enum GradeBandEnum {
    BandPreKtoK = "PreK-K",
    BandKto2 = "K-2",
    Band3to5 = "3-5",
    Band6to8 = "6-8",
    Band9to12 = "9-12",
    Band13Plus = "13+",
}

export const ORDERED_GRADE_KEYS = [
    GradeBandEnum.BandPreKtoK,
    GradeBandEnum.BandKto2,
    GradeBandEnum.Band3to5,
    GradeBandEnum.Band6to8,
    GradeBandEnum.Band9to12,
]

export const GRADE_BANDS: GradeBand[] = [
    {
        gtmLabel: GradeBandEnum.BandPreKtoK,
        label: GradeBandEnum.BandPreKtoK,
        uri: GradeBandEnum.BandPreKtoK,
        description:
            "Find early learning resources for preschool and kindergarten that support the critical transition to school.  Inspire your students with videos, games, and activities aligned to state and national standards.",
        metaTitle: "Early Learning Resources for PreK and K",
    },
    {
        gtmLabel: GradeBandEnum.BandKto2,
        label: GradeBandEnum.BandKto2,
        uri: GradeBandEnum.BandKto2,
        description:
            "Find early elementary resources and lessons. Inspire your students with videos, games, and activities aligned to state and national standards.",
        metaTitle: "Elementary Resources For K to 2",
    },
    {
        gtmLabel: GradeBandEnum.Band3to5,
        label: GradeBandEnum.Band3to5,
        uri: GradeBandEnum.Band3to5,
        description:
            "Find elementary resources and lessons. Inspire your students with videos, games, and activities aligned to state and national standards.",
        metaTitle: "Elementary Resources For 3 to 5",
    },
    {
        gtmLabel: GradeBandEnum.Band6to8,
        label: GradeBandEnum.Band6to8,
        uri: GradeBandEnum.Band6to8,
        description:
            "Find resources for middle school learners. Inspire your students with videos, games, and activities aligned to state and national standards.",
        metaTitle: "Resources For Middle School Lesson Plans",
    },
    {
        gtmLabel: GradeBandEnum.Band9to12,
        label: GradeBandEnum.Band9to12,
        uri: GradeBandEnum.Band9to12,
        description:
            "Find resources and activities for high school learners. Inspire your students with videos, games, and activities aligned to state and national standards.",
        metaTitle: "Resources For High School Lesson Plans",
    },
]

export const DeprecatedGradeURImap = {
    prek: GradeBandEnum.BandPreKtoK,
    "early-elementary": GradeBandEnum.BandKto2,
    "upper-elementary": GradeBandEnum.Band3to5,
    "middle-school": GradeBandEnum.Band6to8,
    "high-school": GradeBandEnum.Band9to12,
}

export const ORDERED_MEDIA_TYPES = [
    "Video",
    "Interactive Lesson",
    "Interactive",
    "Lesson Plan",
    "Media Gallery",
    "Audio",
    "Image",
    "Document",
    "Webpage",
    "Collection",
]

export const SEARCH_FILTERS = [
    "Collection",
    "Video",
    "Interactive Lesson",
    "Interactive",
    "Lesson Plan",
    "Media Gallery",
    "Audio",
    "Image",
    "Document",
    "Webpage",
]

export const ADD_ON_ALLOWED_MEDIA_TYPES = [
    "Video",
    "Interactive",
    "Media Gallery",
    "Audio",
    "Image",
    "Document",
    "Webpage",
]

export const MEDIA_DROPDOWN_FILTERS = [
    "Video",
    "Interactive",
    "Media Gallery",
    "Audio",
    "Image",
    "Document",
    "Webpage",
]

export const STATIC_IMAGES = {
    error_401: "https://static.pbslearningmedia.org/static/assets/static-images/401error.png",
    error_404: "https://static.pbslearningmedia.org/static/assets/static-images/404error.png",
    error_500: "https://static.pbslearningmedia.org/static/assets/static-images/500error.png",
    auth_facebook:
        "https://static.pbslearningmedia.org/static/assets/static-images/auth-facebook.svg",
    auth_google: "https://static.pbslearningmedia.org/static/assets/static-images/auth-google.svg",
    btn_remind_share_light_round_normal_2x:
        "https://static.pbslearningmedia.org/static/assets/static-images/btn_remind_share_light_round_normal_2x.png",
    classroom_color_round:
        "https://static.pbslearningmedia.org/static/assets/static-images/classroom-color-round.png",
    default_subcollection_banner:
        "https://static.pbslearningmedia.org/static/assets/static-images/default_subcollection_banner.png",
    google_classroom_gray_stroke_icon:
        "https://static.pbslearningmedia.org/static/assets/static-images/google_classroom_grey_stroke_icon.png",
    google_classroom_x48_yellow_stroke_icon:
        "https://static.pbslearningmedia.org/static/assets/static-images/google_classroom_x48_yellow_stroke_icon.png",
    lost_in_space:
        "https://static.pbslearningmedia.org/static/assets/static-images/Lost-in-Space.png",
    on_the_go: "https://static.pbslearningmedia.org/static/assets/static-images/On-the-go.png",
    pbslm_logo: "https://static.pbslearningmedia.org/static/assets/static-images/pbslm-logo.svg",
    pbslm_logo_open_area_inverse:
        "https://static.pbslearningmedia.org/static/assets/static-images/PBSLM-Logo-Open-Area-Inverse.svg",
    pbslm_logo_open_area:
        "https://static.pbslearningmedia.org/static/assets/static-images/PBSLM-Logo-Open-Area.svg",
    pbslm_logo_white:
        "https://static.pbslearningmedia.org/static/assets/static-images/pbslm-logo-white.svg",
    pbs_logo: "https://static.pbslearningmedia.org/static/assets/static-images/PBS-logo.svg",
    pbs_logo_white:
        "https://static.pbslearningmedia.org/static/assets/static-images/PBS-logo-white.svg",
    pbs_logo_white_with_text:
        "https://static.pbslearningmedia.org/static/assets/static-images/PBS-logo-white-with-text.svg",
    placeholder_image:
        "https://static.pbslearningmedia.org/static/assets/static-images/placeholder-image.svg",
    student_site_hero:
        "https://static.pbslearningmedia.org/static/assets/static-images/Student_siteHero.jpg",
    student_teacher_laptop:
        "https://static.pbslearningmedia.org/static/assets/static-images/Student-Teacher-Laptop.png",
    teacher_and_students:
        "https://static.pbslearningmedia.org/static/assets/static-images/teacher-and-students.png",
    teacher_small:
        "https://static.pbslearningmedia.org/static/assets/static-images/teacher-small.jpg",
    teacher: "https://static.pbslearningmedia.org/static/assets/static-images/teacher.jpg",
    default_student_hero:
        "https://static.pbslearningmedia.org/static/assets/static-images/Student_siteHero.jpg",
    STUDENT: {
        arrow_down:
            "https://static.pbslearningmedia.org/static/assets/static-images/student/arrow-down.png",
        check: "https://static.pbslearningmedia.org/static/assets/static-images/student/check.svg",
        corner:
            "https://static.pbslearningmedia.org/static/assets/static-images/student/corner.svg",
        curved_arrow_down:
            "https://static.pbslearningmedia.org/static/assets/static-images/student/curved-down-arrow.svg",
        icon_updown_op1:
            "https://static.pbslearningmedia.org/static/assets/static-images/student/icn-updown_op1.png",
        stuff: "https://static.pbslearningmedia.org/static/assets/static-images/student/stuff.svg",
    },
    ABOUT: {
        icon_security:
            "https://static.pbslearningmedia.org/static/assets/static-images/about/Icon-Security.svg",
        icon_filter:
            "https://static.pbslearningmedia.org/static/assets/static-images/about/Icon-Filter.svg",
        icon_reach:
            "https://static.pbslearningmedia.org/static/assets/static-images/about/Icon-Reach.svg",
        icon_standards:
            "https://static.pbslearningmedia.org/static/assets/static-images/about/Icon-Standards.svg",
        feature_icon_collections:
            "https://static.pbslearningmedia.org/static/assets/static-images/about/Feature-Icon-Collections.svg",
        feature_icon_favorites:
            "https://static.pbslearningmedia.org/static/assets/static-images/about/Feature-Icon-Favorites.svg",
        feature_icon_integrations:
            "https://static.pbslearningmedia.org/static/assets/static-images/about/Feature-Icon-Integrations.svg",
        feature_icon_lesson_builder:
            "https://static.pbslearningmedia.org/static/assets/static-images/about/Feature-Icon-LessonBuilder.svg",
    },
}

export const ALIASED_FACETS = ["cp", "cs", "ct", "subject"]

export const CH_FACET_ID = "ch"

export enum DrawerTabTitle {
    MyFavorites = 1,
    EntireSite,
    Upload,
    Instructions,
}

export enum BrowseByViews {
    Initial = 1,
    Subjects,
    Grades,
    Discipline,
}
